var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$store.state.status.common.isAppLoading)?_c('Loader'):_c('div',[_c('Header'),_c('router-view'),_c('Footer')],1),_c('modal-error'),_c('modal-website'),_c('modal-default')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }